import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { useIntl } from 'react-intl-next';
import { NotificationFeed, NotificationGroup } from '@atlassian/notification-common';
import { useIsGroupsMarkAllAsReadVisible, useNotificationGroup, useNotificationGroups, useNotificationsLoadingState, useNotificationStateFilters, useTimeGroupedNotificationGroups } from '@atlassian/notification-store';
function NotificationList(_ref) {
  var updateGroupingHeaders = _ref.updateGroupingHeaders,
    product = _ref.product,
    showThirdPartyNotificationNudge = _ref.showThirdPartyNotificationNudge,
    ThirdPartyNotificationNudge = _ref.ThirdPartyNotificationNudge;
  var intl = useIntl();
  var _useNotificationGroup = useNotificationGroups(),
    _useNotificationGroup2 = _slicedToArray(_useNotificationGroup, 1),
    groups = _useNotificationGroup2[0];
  var _useNotificationState = useNotificationStateFilters(),
    _useNotificationState2 = _slicedToArray(_useNotificationState, 1),
    filters = _useNotificationState2[0];
  var _useNotificationsLoad = useNotificationsLoadingState(filters),
    _useNotificationsLoad2 = _slicedToArray(_useNotificationsLoad, 1),
    currentCategoryState = _useNotificationsLoad2[0];
  var isMarkAllAsReadVisible = useIsGroupsMarkAllAsReadVisible();
  var timeGroups = useTimeGroupedNotificationGroups(groups);
  var _useNotificationGroup3 = useNotificationGroup({
      locale: intl.locale
    }),
    fetch = _useNotificationGroup3.fetch,
    handleMarkGroup = _useNotificationGroup3.handleMarkGroup,
    handleMarkGroupNotifications = _useNotificationGroup3.handleMarkGroupNotifications,
    handleMarkAllGroupsAsRead = _useNotificationGroup3.handleMarkAllGroupsAsRead;
  return /*#__PURE__*/React.createElement(NotificationFeed, {
    notificationTimeGroups: timeGroups,
    fetchState: currentCategoryState.fetchState,
    isMarkAllAsReadVisible: isMarkAllAsReadVisible,
    markAllNotificationsRead: handleMarkAllGroupsAsRead,
    updateGroupingHeaders: updateGroupingHeaders,
    renderDataItem: function renderDataItem(dataItem, listIndex) {
      return /*#__PURE__*/React.createElement(NotificationGroup, {
        listIndex: listIndex,
        notificationGroup: dataItem,
        onGroupExpanded: fetch,
        onGroupNotificationsReadStateChange: handleMarkGroupNotifications,
        onGroupReadStateChange: handleMarkGroup
      });
    },
    product: product,
    showThirdPartyNotificationNudge: showThirdPartyNotificationNudge,
    ThirdPartyNotificationNudge: ThirdPartyNotificationNudge
  });
}
export default NotificationList;